<div [ngClass]="props.inputClass ? props.inputClass : 'col-form-label'">
  {{ textValue }}
</div>
